import { render, staticRenderFns } from "./PdfGenerator.vue?vue&type=template&id=2c83a6ac&scoped=true&"
import script from "./PdfGenerator.vue?vue&type=script&lang=js&"
export * from "./PdfGenerator.vue?vue&type=script&lang=js&"
import style0 from "./PdfGenerator.vue?vue&type=style&index=0&id=2c83a6ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c83a6ac",
  null
  
)

export default component.exports